var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "mArticle" } }, [
    _vm.totalBookmarks
      ? _c(
          "div",
          { staticClass: "my-bookmark" },
          [
            _c("h3", { staticClass: "sr_only" }, [_vm._v("북마크")]),
            _vm._v(" "),
            _c("bookmark-count", {
              attrs: {
                tags: _vm.tags,
                "focused-tag": _vm.focusedTag,
                total: _vm.totalBookmarks,
              },
            }),
            _vm._v(" "),
            _vm.tags.length > 1
              ? _c("div", { staticClass: "my-bookmark__tag-area" }, [
                  _c(
                    "a",
                    {
                      staticClass: "my-bookmark__tag-area__toggle #tag_folder",
                      attrs: { href: "javascript:" },
                      on: { click: _vm.toggleTagList },
                    },
                    [
                      _vm._v("#태그"),
                      _c(
                        "span",
                        {
                          class: [_vm.isTagListOpen ? "ico-open" : "ico-fold"],
                        },
                        [
                          _c("span", { staticClass: "sr_only" }, [
                            _vm._v("목록 열기 / 닫기"),
                          ]),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "my-bookmark__scroll-tag",
                        _vm.isTagListOpen
                          ? "my-bookmark__scroll-tag--open"
                          : "",
                      ],
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "my-bookmark__scroll-tag__inner",
                          style: _vm.style.innerScroll,
                        },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "hammer",
                                  rawName: "v-hammer:pan",
                                  value: _vm.onPan,
                                  expression: "onPan",
                                  arg: "pan",
                                },
                              ],
                              staticClass: "my-bookmark__slide",
                              style: _vm.style.slide,
                            },
                            _vm._l(_vm.tagPageIndices, function (i) {
                              return _c("tag-list", {
                                attrs: {
                                  "tag-list": _vm._f("filterByPage")(
                                    _vm.tags,
                                    i,
                                    _vm.tagsPerPage
                                  ),
                                  focused: _vm.focusedTag,
                                  page: i,
                                  "max-page": _vm.maxTagPage,
                                },
                                on: { "tag-select": _vm.onTagSelect },
                              })
                            }),
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "my-bookmark__tag-guide" }, [
                        _c(
                          "p",
                          {
                            staticClass: "my-bookmark__tag-guide__description",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "my-bookmark__tag-guide__link #w2a_bookmark",
                                attrs: { href: "javascript:" },
                                on: {
                                  click: function ($event) {
                                    return _vm.goToApp()
                                  },
                                },
                              },
                              [_vm._v("카페앱")]
                            ),
                            _vm._v("에서 태그를 추가&편집하여"),
                            _c("br"),
                            _vm._v("나만의 북마크 목록을 만들어보세요."),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "my-bookmark__tag-guide__paging" },
                          [
                            _c(
                              "em",
                              {
                                staticClass:
                                  "my-bookmark__tag-guide__paging__current-page",
                              },
                              [_vm._v(_vm._s(_vm.tagPage + 1))]
                            ),
                            _vm._v("/" + _vm._s(_vm.maxTagPage)),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ])
              : _c("div", { staticClass: "empty-tag-info" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "empty-tag-info__to-cafe-app #w2a_bookmark",
                      attrs: { href: "javascript:" },
                      on: {
                        click: function ($event) {
                          return _vm.goToApp()
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "ico-cafe-emblem" }),
                      _vm._v("카페앱으로 보기\n\t\t\t"),
                    ]
                  ),
                ]),
            _vm._v(" "),
            _c("bookmark-list", {
              attrs: {
                bookmark: _vm.bookmark,
                "post-list": _vm.currentBookmarks,
              },
              on: { delete: _vm.onBookmarkDelete },
            }),
            _vm._v(" "),
            _c("pagination", {
              attrs: {
                page: _vm.bookmarkPage,
                "max-page": _vm.maxBookmarkPage,
              },
              on: { "page-select": _vm.onPageSelect },
            }),
          ],
          1
        )
      : _c("div", { staticClass: "my-bookmark" }, [
          _c("h3", { staticClass: "sr_only" }, [_vm._v("북마크")]),
          _vm._v(" "),
          _vm._m(1),
        ]),
    _vm._v(" "),
    _c("div", { staticClass: "cafe-make" }, [
      _vm._m(2),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "cafe-make__link #create_cafe",
          attrs: { href: "/_makeCafe", click: _vm.makeCafe },
        },
        [
          _c("span", { staticClass: "cafe-make__icon" }),
          _vm._v("카페 만들기\n\t\t"),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "empty-tag-info__description" }, [
      _vm._v("카페앱에서 태그를 추가&편집하여"),
      _c("br"),
      _vm._v("나만의 북마크 목록을 만들어 보세요."),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "bookmark-info" }, [
      _c("img", {
        attrs: {
          src: "//t1.daumcdn.net/cafe_image/mobile/m640/bookmark-info_240322.png",
          width: "161",
          height: "121",
          alt: "북마크 하는 방법",
        },
      }),
      _vm._v(" "),
      _c(
        "strong",
        { staticClass: "bookmark-info__title bookmark-info__title--underline" },
        [_vm._v("\n\t\t\t\t북마크한 글이 없습니다.\n\t\t\t")]
      ),
      _vm._v(" "),
      _c("p", { staticClass: "bookmark-info__description" }, [
        _vm._v("게시글 하단 더보기 버튼을 누르고"),
        _c("br"),
        _vm._v("마음에 드는 글을 북마크 해보세요."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("strong", { staticClass: "cafe-make__title" }, [
      _vm._v("관심있는 주제의 카페를"),
      _c("br"),
      _vm._v(" 직접 개설하고 운영해 보세요!"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }